<template>
  <div
    class="column"
    id="websites-column"
    :class="{
      'loaded-website': readyToShowItems,
      'empty-list': !websites.length,
    }"
  >
    <div class="header">
      <slot name="title">
        <h5>Selecteer winkel</h5>
      </slot>
      <FormInput
        v-model.trim="search"
        class="input"
        placeholder="Search website"
      />
    </div>
    <div
      class="scroll-wrapper d-flex justify-content-center align-items-center"
      :class="{ 'disable-ske': readyToShowItems }"
    >
      <InfiniteScrolling
        v-if="!readyToShowItems || (websites && websites.length)"
        class="infinite-scrolling"
        ref="scroller"
        :searchMore="searchMore"
        :show-end="showEnd"
      >
        <WebsiteItem
          v-for="item in getWebsites"
          :key="item.uid"
          v-bind="item"
          :active="item.uid === value && readyToShowItems"
          :use-radio="true"
          class="website-option"
          @click.native="selectWebsite(item.uid)"
        >
          <template #radio-button>
            <slot name="website-radio" v-bind="item"></slot>
          </template>
          <template #after>
            <slot name="after" v-bind="item"></slot>
          </template>
        </WebsiteItem>
      </InfiniteScrolling>
      <div v-else>
        <EmptyStatePlaceholder
          title="Er zijn geen websites beschikbaar"
          description="U kunt naar het tabblad Websites gaan om ze te beheren"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z"
              clip-rule="evenodd"
            />
          </svg>
        </EmptyStatePlaceholder>
      </div>
    </div>
  </div>
</template>

<script>
import WebsiteItem from "./WebsiteItem.vue";

import FormInput from "src/components/Inputs/FormInput.vue";
import InfiniteScrolling from "src/layout/InfiniteScrolling.vue";
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue";

const placeholder = [
  {
    domainname: "http://verda.name",
    status: "active",
    products: 175,
    size: "small",
  },
  {
    domainname: "htt.name",
    status: "blocked",
    products: 34,
    size: "medium",
  },
];

let timeout;

export default {
  props: {
    value: [String, Number],
    loading: Boolean,
  },
  components: {
    WebsiteItem,
    FormInput,
    EmptyStatePlaceholder,
    InfiniteScrolling,
  },
  data() {
    return {
      selected: this.value || null,

      search: "",
      // loaded: true,
      showEnd: false,
      websites: [],
    };
  },
  async created() {
    this.showEnd = !(await this.searchMore(1));
    // this.loaded = true
  },
  methods: {
    async resetAndRefetch() {
      // this.loaded = false
      // this.websites = []
      this.showEnd = !(await this.searchMore(1, true));
      // this.loaded = true
    },

    selectWebsite(uid) {
      this.selected = uid;
      this.$emit("website-click", uid);
    },
    async requestWebsites(page = 1) {
      let res;
      try {
        res = await this.axios.get("/api/websites", {
          params: {
            name: this.search,
            page,
          },
        });
      } catch (err) {
        if (err && err.response && err.response.status === 401) {
          this.$logout();
        }
        throw err;
      }

      return (res && res.data.results) || [];
    },
    async searchMore(page, replace) {
      const sites = await this.requestWebsites(page);

      if (replace) {
        this.websites = sites;
      } else {
        this.websites.push(...sites);
      }
      return sites.length === 0 || sites.length < 10;
    },
  },
  computed: {
    getWebsites() {
      return this.readyToShowItems ? this.websites : this.placeholderWebsites;
    },
    placeholderWebsites() {
      return [
        ...placeholder,
        ...placeholder,
        ...placeholder,
        ...placeholder,
        placeholder[0],
      ];
    },
    readyToShowItems() {
      return true;
      // return this.loaded && !this.loading
    },
  },
  watch: {
    websites(val) {
      this.$emit("loaded-websites", val);
    },
    search(val) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      timeout = setTimeout(async () => {
        this.websites = await this.requestWebsites();
        this.$refs.scroller.reset();
        this.$el.scrollTo(0, 0);
      });
    },
    selected(uid) {
      this.$emit("input", uid);
    },
    value(uid) {
      this.selected = uid;
    },
  },
};
</script>

<style scoped>
.input {
  z-index: 0 !important;
}

.column {
  width: 250px;
  max-height: 100%;
  border-right: 1px solid rgb(229, 231, 235);
  overflow: auto;
  flex-shrink: 0;
}

.header {
  padding: 12px;
  padding-top: 18px;
  padding-bottom: 0px;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10000 !important;
}

.scroll-wrapper,
.infinite-scrolling {
  min-height: 550px;
}

.scroll-wrapper {
  position: relative;
}

.infinite-scrolling {
  flex-basis: 100%;
}

h5 {
  color: rgb(17, 24, 39);
  font-weight: 600;
}
</style>
